<template>
  <v-menu
    v-model="menuStart"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="computedDataFormatted"
        :label="label"
        prepend-inner-icon="mdi-calendar"
        readonly
        outlined
        dense
        v-bind="attrs"
        v-on="on"
        clearable
        @click:clear="clearData"
      ></v-text-field>
    </template>
    <v-date-picker v-model="data" no-title scrollable @input="menuStart = false" @change="onDataChange"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    label: String,
    initDate: String
  },
  data() {
    return {
      data: null,
      menuStart: false
    }
  },
  mounted() {
    if (this.initDate) {
      this.data = this.initDate
    }
  },
  watch: {
    initDate(value) {
      this.data = value
    }
  },
  computed: {
    computedDataFormatted () {
      return this.formatDate(this.data)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    onDataChange() {
      this.$emit('change', this.data)
    },
    clearData() {
      this.data = null
      this.onDataChange()
    }
  }
}
</script>
